/* eslint-disable react/prop-types */
import React from 'react';
import { usePacDrawer } from '@thd-olt-component-react/loyalty-benefits';
import { Drawer } from '@one-thd/sui-atomic-components';
import { pkPLCCBanner } from '../../../../constants/ProXtraPerks';
import { ModalMobileCardLabel, ModalQualifyingSpend, ModalQualifyingSpendLabel, ModalUnlockNextPerk, ModalMoreBenefitsList, ModalCloseButton, } from '../../../PerksPage/PLCCBanner/components/ModalComponents';
import '../../../PerksPage/PLCCBanner/PLCCBanner.scss';
import { PxccMultiplierCard } from '../../../../images/ProXtraCreditCard';
import { clickCta, setOverlayEvent } from '../../../../utils/analytics';
import { InfoPerksContext, InfoRewardsContext } from '../../../../contexts';
var renderHeaderText = function (_a) {
    var _b, _c;
    var plccSwitch = _a.plccSwitch, perksInfo = _a.perksInfo;
    return ({
        headerStr: pkPLCCBanner.plccCardL,
        titleStr: plccSwitch
            ? "You're Earning ".concat(perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor, "X Faster!")
            : "Earn Perks ".concat(perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor, "X Faster"),
        subTitleStr: plccSwitch
            ? "".concat((_c = (_b = perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.accrualData) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.year, " Pro Xtra Perks Spend Details")
            : 'Sign up for the Pro Xtra Credit Card',
    });
};
var RenderIconComponent = function (_a) {
    var plccSwitch = _a.plccSwitch;
    return plccSwitch ? React.createElement(PxccMultiplierCard, null) : React.createElement(PxccMultiplierCard, { hideMultiplier: true });
};
var ContentUnenrolled = function (_a) {
    var perksInfo = _a.perksInfo, isMobile = _a.isMobile;
    return (React.createElement("div", null,
        React.createElement("div", { className: "sui-text-sm" },
            React.createElement(ModalQualifyingSpend, { accrualData: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.accrualData, activePxccFactor: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor, onClick: function () {
                    clickCta('rewards hub: pro xtra credit card overlay: qualifying spend tooltip');
                } })),
        React.createElement(ModalQualifyingSpendLabel, { activePxccFactor: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor, isMobile: isMobile }),
        React.createElement(ModalUnlockNextPerk, { accrualData: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.accrualData, activePxccFactor: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor, isMobile: isMobile })));
};
var ContentEnrolled = function (_a) {
    var perksInfo = _a.perksInfo, isMobile = _a.isMobile, setTogglePLCC = _a.setTogglePLCC, plccSwitch = _a.plccSwitch;
    return (React.createElement("div", null,
        React.createElement(ModalMobileCardLabel, { hideCardLogo: true, activePxccFactor: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor }),
        React.createElement(ModalUnlockNextPerk, { accrualData: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.accrualData, activePxccFactor: perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.activePxccFactor, isMobile: isMobile }),
        React.createElement(ModalMoreBenefitsList, null),
        React.createElement(ModalCloseButton, { setTogglePLCC: setTogglePLCC, plccSwitch: plccSwitch })));
};
var RenderDrawerComponent = function (_a) {
    var elementData = _a.elementData;
    var DrawerComponent = usePacDrawer(elementData).DrawerComponent;
    return React.createElement(DrawerComponent, null);
};
export var PacPxccDrawer = function (props) {
    var togglePlcc = props.togglePlcc, setTogglePLCC = props.setTogglePLCC, perksInfo = props.perksInfo, plccSwitch = props.plccSwitch, isMobile = props.isMobile;
    var isLoadingPerks = React.useContext(InfoPerksContext).isLoading;
    var _a = React.useContext(InfoRewardsContext), isLoadingRewards = _a.isLoading, isBlendedRewardsEnabled = _a.isBlendedRewardsEnabled;
    var isLoading = isBlendedRewardsEnabled ? isLoadingRewards : isLoadingPerks;
    React.useEffect(function () {
        if (togglePlcc) {
            setOverlayEvent("rewards hub: pro xtra credit card ".concat(plccSwitch ? 'enrolled' : 'unenrolled'));
        }
    }, [togglePlcc]);
    var IconComponent = function () { return React.createElement(RenderIconComponent, { plccSwitch: plccSwitch }); };
    var _b = renderHeaderText({
        plccSwitch: plccSwitch,
        perksInfo: perksInfo,
    }), headerStr = _b.headerStr, titleStr = _b.titleStr, subTitleStr = _b.subTitleStr;
    var onCloseFunc = function () { return setTogglePLCC(false); };
    var ContentEle = function () {
        return plccSwitch ? (React.createElement(ContentUnenrolled, { perksInfo: perksInfo, isMobile: isMobile })) : (React.createElement(ContentEnrolled, { perksInfo: perksInfo, isMobile: isMobile, setTogglePLCC: setTogglePLCC, plccSwitch: plccSwitch }));
    };
    var elementData = {
        headerStr: headerStr,
        titleStr: titleStr,
        subTitleStr: subTitleStr,
        IconComponent: IconComponent,
        ContentEle: ContentEle,
        onCloseFunc: onCloseFunc,
    };
    var DrawerComponent = function () {
        return React.useMemo(function () { return React.createElement(RenderDrawerComponent, { elementData: elementData }); }, [isLoading]);
    };
    var DrawerWrapper = function (_a) {
        var children = _a.children;
        return (React.createElement(Drawer, { position: "right", open: togglePlcc, DrawerRootProps: isMobile ? { height: '85%' } : undefined, onClose: function () { return setTogglePLCC(false); } }, children));
    };
    return (React.createElement(DrawerWrapper, null,
        React.createElement(DrawerComponent, null)));
};
